export enum DropdownPosition {
	RIGHT = 'right',
	BOTTOM = 'bottom'
}